/* House & Co. 3.1 — scroll choreography (GSAP + ScrollTrigger, loaded only on pages that use it).
   Every scene answers one question. Hero: what is this. Range: what do you make. Dilution: why is 500 ml enough.
   How: what do I do with it. Everything else gets quiet reveals, parallax and counters. Transforms + opacity only. */
(() => {
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const ready = () => window.gsap && window.ScrollTrigger;
  if (RM || !ready()) { document.documentElement.classList.add('motion-static'); return; }
  gsap.registerPlugin(ScrollTrigger);
  const rtl = document.documentElement.dir === 'rtl';
  const dir = rtl ? -1 : 1;
  const desktop = matchMedia('(min-width: 990px)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- words: headings marked data-words rise one word at a time ---------- */
  const splitWords = (el) => {
    if (el.dataset.split) return $$('.w > span', el);
    const text = el.textContent.trim(); el.textContent = ''; el.dataset.split = '1';
    text.split(/\s+/).forEach((w, i, a) => {
      const o = document.createElement('span'); o.className = 'w'; const s = document.createElement('span'); s.textContent = w; o.appendChild(s); el.appendChild(o);
      if (i < a.length - 1) el.appendChild(document.createTextNode(' '));
    });
    return $$('.w > span', el);
  };
  $$('[data-words]').forEach((h) => {
    const words = splitWords(h);
    const inHero = !!h.closest('[data-range]');
    gsap.from(words, { yPercent: 110, rotate: 2 * dir, opacity: 0, duration: 1.1, ease: 'expo.out', stagger: .06, delay: inHero ? .15 : 0,
      scrollTrigger: inHero ? null : { trigger: h, start: 'top 85%', once: true } });
  });

  /* ---------- hero + range: one pinned story ----------
     Act 1 (one screen): a macro close-up of the first label pulls back to the full bottle.
     Act 2 (one screen per bottle): a diagonal colour wipe sweeps in the next ground while the next bottle slides in. */
  $$('[data-range]').forEach((sec) => {
    const pin = $('.range__pin', sec);
    const btls = $$('.range__btl', sec);
    const ghosts = $$('.range__ghost', sec);
    const slots = $$('.range__slot > div', sec);
    const dots = $$('.range__dots i', sec);
    const intro = $('[data-intro]', sec);
    const wipe = $('[data-wipe]', sec);
    const n = btls.length; if (n < 1) return;
    const set = (i) => {
      slots.forEach((s, k) => s.classList.toggle('is-on', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      const b = btls[i]; pin.style.setProperty('--ground', b.dataset.ground); pin.style.setProperty('--ink', b.dataset.ink);
      pin.style.color = b.dataset.ink;
    };
    set(0); pin.style.backgroundColor = btls[0].dataset.ground;
    const front = (b) => $('img.btl:not(.btl--q)', b) || $('.btl', b);
    const quarter = (b) => $('.btl--q', b);
    const MACRO = desktop ? 2.15 : 1.33;
    gsap.set(btls.slice(1), { opacity: 0, xPercent: 80 * dir, scale: .92 });
    gsap.set(ghosts, { opacity: 0, xPercent: 14 * dir });
    gsap.set(btls[0], { opacity: 1, scale: MACRO, yPercent: desktop ? -14 : 6, transformOrigin: '50% 40%' });   // label centred below the headline   // the label fills the screen
    btls.forEach((b) => { const q = quarter(b); if (q) gsap.set(q, { opacity: 0 }); });
    if (wipe) gsap.set(wipe, { clipPath: 'polygon(130% 0%, 200% 0%, 200% 100%, 160% 100%)' });

    const tl = gsap.timeline({ defaults: { ease: 'power2.inOut' } });
    // act 1: pull back
    tl.to(btls[0], { scale: 1, yPercent: 0, duration: .85, ease: 'power3.inOut' }, .05)
      .to(intro, { yPercent: -24, opacity: 0, duration: .5, ease: 'power1.in' }, .3)
      .to(ghosts[0], { opacity: 1, xPercent: 0, duration: .4, ease: 'power2.out' }, .55);
    for (let i = 0; i < n; i++) {
      const at = 1 + i;
      const b = btls[i], f = front(b), q = quarter(b);
      tl.to(b, { rotate: -2.5 * dir, yPercent: -2, duration: .7, ease: 'sine.inOut' }, at + .05);
      if (ghosts[i]) tl.to(ghosts[i], { xPercent: -16 * dir, duration: .9, ease: 'none' }, at + .05);
      if (i < n - 1) {
        const h = at + .68, nb = btls[i + 1];
        if (wipe) tl.set(wipe, { backgroundColor: nb.dataset.ground, clipPath: 'polygon(130% 0%, 200% 0%, 200% 100%, 160% 100%)' }, h)
          .to(wipe, { clipPath: 'polygon(-30% 0%, 200% 0%, 200% 100%, -60% 100%)', duration: .42, ease: 'power3.inOut' }, h)
          .set(pin, { backgroundColor: nb.dataset.ground }, h + .42)
          .set(wipe, { clipPath: 'polygon(130% 0%, 200% 0%, 200% 100%, 160% 100%)' }, h + .421);
        tl.to(b, { xPercent: -90 * dir, scale: .92, rotate: -5 * dir, opacity: 0, duration: .42, ease: 'power3.inOut' }, h)
          .to(ghosts[i], { opacity: 0, xPercent: -40 * dir, duration: .25 }, h)
          .fromTo(nb, { opacity: 0, xPercent: 90 * dir, scale: .94, rotate: 4 * dir }, { opacity: 1, xPercent: 0, scale: 1, rotate: 0, duration: .46, ease: 'power3.out' }, h + .1)
          .fromTo(ghosts[i + 1], { opacity: 0, xPercent: 24 * dir }, { opacity: 1, xPercent: 0, duration: .3, ease: 'power2.out' }, h + .2);
      }
    }
    const total = 1 + n;
    let last = 0;
    ScrollTrigger.create({
      trigger: sec, start: 'top top', end: () => `+=${window.innerHeight * (total - .3)}`,
      pin, scrub: 1.1, animation: tl, anticipatePin: 1, invalidateOnRefresh: true,
      snap: { snapTo: (v) => { const s = Math.round(v * total - .25); return Math.min(1, Math.max(0, (s + .25) / total)); }, duration: { min: .35, max: .9 }, ease: 'power3.inOut', delay: .15 },
      onUpdate: (self) => { const t = self.progress * total; const i = Math.min(n - 1, Math.max(0, Math.floor(t - 1 + .3))); if (i !== last) { last = i; set(i); } }
    });
    if (fine) {
      let raf = 0;
      pin.addEventListener('pointermove', (e) => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const r = pin.getBoundingClientRect(); const x = (e.clientX - r.left) / r.width - .5; const y = (e.clientY - r.top) / r.height - .5; $$('.range__stage', sec).forEach(st => st.style.transform = `perspective(1200px) rotateY(${x * 8}deg) rotateX(${-y * 5}deg)`); }); });
      pin.addEventListener('pointerleave', () => $$('.range__stage', sec).forEach(st => st.style.transform = ''));
    }
  });

  /* ---------- dilution: the Count fills to twenty, litres climb to ten, water rises behind ---------- */
  $$('[data-dilution]').forEach((sec) => {
    const dots = $$('.count i', sec).slice(1);
    const fig = $('[data-litres]', sec);
    const btl = $('.dil__btl', sec);
    const wave = $('.dil__wave', sec);
    const max = Number(sec.dataset.litres || 10);
    const state = { p: 0 };
    const draw = () => {
      const k = Math.round(state.p * dots.length);
      dots.forEach((d, i) => d.classList.toggle('is-water', i < k));
      if (fig) fig.textContent = (0.5 + state.p * (max - .5)).toFixed(state.p > .98 ? 0 : 1).replace(/\.0$/, '');
    };
    draw();
    const tl = gsap.timeline();
    tl.to(state, { p: 1, ease: 'none', onUpdate: draw, duration: 1 }, 0);
    if (wave) tl.fromTo(wave, { scaleY: .04 }, { scaleY: 1, ease: 'none', duration: 1 }, 0);
    if (btl) tl.fromTo(btl, { rotate: -4 * dir, yPercent: 6 }, { rotate: 6 * dir, yPercent: -4, ease: 'none', duration: 1 }, 0);
    ScrollTrigger.create({ trigger: sec, start: 'top top', end: () => `+=${window.innerHeight * 1.4}`, pin: $('.dil__pin', sec), scrub: .5, animation: tl, invalidateOnRefresh: true });
  });

  /* ---------- how it works v4: one bottle on one stage; geometry measured, so the pour always lands in the neck ---------- */
  $$('[data-how]').forEach((sec) => {
    const steps = $$('.how__step', sec), dots = $$('.how__dots i', sec), bar = $('[data-how-bar]', sec), stage = $('[data-stage]', sec);
    const conc = $('[data-conc]', sec), body = $('[data-body]', sec), head = $('[data-head]', sec), btl = $('[data-btl]', sec);
    const svg = $('.hiw4__liquid', sec), liq = $('[data-liq]', sec), wave = $('[data-wave]', sec), wg = $('[data-wavegrp]', sec);
    const sc = $('[data-sc]', sec), sw = $('[data-sw]', sec), tap = $('[data-tap]', sec), ml = $('[data-ml]', sec), done = $('[data-done]', sec), bubbles = $$('[data-bubble]', sec);
    if (!stage || !body) return;
    const SH = { neck: +svg.dataset.neck, shoulder: +svg.dataset.shoulder, base: +svg.dataset.base };
    const lvl = (f) => SH.base - (SH.base - SH.shoulder) * f;               // svg y for a fill fraction
    const g = { cx: 0, cy: 0 };
    const measure = () => {
      const s = stage.getBoundingClientRect(), b = body.getBoundingClientRect(), c = conc.getBoundingClientRect();
      const u = b.width / 840, mouth = { x: b.left + b.width / 2 - s.left, y: b.top + SH.neck * u - s.top };
      const L = s.height * .12, L2 = s.height * .2, r = c.height * .47;        // pour stream, water stream, cap radius
      const tip = { x: mouth.x, y: mouth.y - L };                              // where the concentrate's cap ends up
      g.cx = tip.x - .883 * r * dir - (c.left + c.width / 2 - s.left);           // a 118-degree tilt puts the cap at the tip
      g.cy = tip.y - .469 * r - (c.top + c.height / 2 - s.top);
      gsap.set(sc, { left: mouth.x - 5 * dir, top: tip.y - 2, height: L + 4 });
      gsap.set(sw, { left: mouth.x - 8 - 10 * dir, top: mouth.y - L2, height: L2 + 6 });
      const tw = s.width * .36, k = tw / 200; gsap.set(tap, { width: tw, left: mouth.x - 10 * dir - 60 * k, top: mouth.y - L2 - 72 * k });
    };
    ScrollTrigger.addEventListener('refreshInit', measure); measure();
    gsap.set(liq, { y: SH.base + 60 }); gsap.set(head, { yPercent: -34, opacity: 0 }); gsap.set(tap, { yPercent: -40, opacity: 0 });
    gsap.set([sc, sw], { scaleY: 0, transformOrigin: '50% 0' }); gsap.set(done, { opacity: 0, scale: .7 });
    gsap.to(wave, { x: -420, duration: 2.6, repeat: -1, ease: 'none' });       // the surface is never dead still
    const active = (i) => { steps.forEach((s, k) => s.classList.toggle('is-on', k === i)); dots.forEach((d, k) => d.classList.toggle('is-on', k <= i)); };
    const mlv = { v: 0 }; const wr = () => { ml.textContent = Math.round(mlv.v) + ' ml'; };
    const tl = gsap.timeline({ defaults: { ease: 'none' } });
    tl.add(() => active(0), 0)
      .to(conc, { y: -14, duration: .08, ease: 'power2.out' }, 0)
      .to(conc, { rotate: 118 * dir, x: () => g.cx, y: () => g.cy, duration: .32, ease: 'power3.inOut' }, .06)
      .to(sc, { scaleY: 1, duration: .07 }, .33)
      .to(liq, { y: lvl(.07), duration: .4, ease: 'power1.out' }, .38)
      .to(mlv, { v: 25, duration: .4, onUpdate: wr }, .38)
      .to(sc, { scaleY: 0, transformOrigin: '50% 100%', duration: .07 }, .78)
      .to(conc, { rotate: 0, x: 0, y: 0, duration: .26, ease: 'power3.inOut' }, .8);
    tl.add(() => active(1), 1)
      .to(tap, { yPercent: 0, opacity: 1, duration: .16, ease: 'back.out(1.6)' }, 1)
      .fromTo(sw, { opacity: .6 }, { scaleY: 1, opacity: 1, duration: .09 }, 1.16)
      .to(liq, { y: lvl(.985), duration: .68, ease: 'power1.inOut' }, 1.2)
      .to(wave, { fill: '#F0CC7A', duration: .68 }, 1.2)
      .to(mlv, { v: 500, duration: .68, onUpdate: wr }, 1.2)
      .fromTo(bubbles, { attr: { cy: SH.base }, opacity: 0 }, { attr: { cy: (i) => 420 + i * 40 }, opacity: .85, stagger: .06, duration: .5, repeat: 1 }, 1.22)
      .to(bubbles, { opacity: 0, duration: .1 }, 1.86)
      .to(sw, { scaleY: 0, opacity: .5, transformOrigin: '50% 100%', duration: .08 }, 1.88)
      .to(tap, { yPercent: -40, opacity: 0, duration: .12, ease: 'power2.in' }, 1.9);
    tl.add(() => active(2), 2)
      .to(head, { yPercent: 0, opacity: 1, duration: .2, ease: 'power2.in' }, 2.02)
      .to(btl, { y: 5, duration: .05, ease: 'power2.out' }, 2.2).to(btl, { y: 0, duration: .12, ease: 'elastic.out(1, .5)' }, 2.25)
      .to(btl, { keyframes: [{ rotate: -9 * dir, x: -6 }, { rotate: 9 * dir, x: 6 }, { rotate: -6 * dir, x: -4 }, { rotate: 5 * dir, x: 3 }, { rotate: 0, x: 0 }], duration: .42, ease: 'power1.inOut' }, 2.3)
      .to(wg, { keyframes: [{ scaleY: 2.6 }, { scaleY: 1 }], transformOrigin: '50% 0', duration: .45, ease: 'power1.inOut' }, 2.3)
      .to(done, { opacity: 1, scale: 1, duration: .18, ease: 'back.out(2)' }, 2.72);
    if (bar) tl.fromTo(bar, { scaleX: 0 }, { scaleX: 1, duration: 3 }, 0);
    active(0);
    ScrollTrigger.create({ trigger: sec, start: 'top top', end: () => `+=${window.innerHeight * 2.8}`, pin: $('.how__pin', sec), scrub: 1, animation: tl, invalidateOnRefresh: true,
      snap: { snapTo: [0, 1 / 3, 2 / 3, 1], duration: { min: .3, max: .8 }, ease: 'power2.inOut', delay: .15 } });
  });

  /* ---------- category tiles: rise in, then drift with the scroll; tilt under the cursor ---------- */
  $$('.bento').forEach((g) => {
    const btls = $$('.tile__btl', g);
    gsap.from(btls, { yPercent: 30, rotate: (i) => (i % 2 ? 6 : -6) * dir, opacity: 0, stagger: .08, duration: 1.2, ease: 'expo.out', scrollTrigger: { trigger: g, start: 'top 80%' } });
    btls.forEach((b, i) => gsap.to(b, { yPercent: (i % 2 ? -14 : -8), ease: 'none', scrollTrigger: { trigger: g, start: 'top bottom', end: 'bottom top', scrub: .8 } }));
    if (fine) $$('.tile', g).forEach((t) => {
      const b = $('.tile__btl', t); if (!b) return;
      t.addEventListener('pointermove', (e) => { const r = t.getBoundingClientRect(); const x = (e.clientX - r.left) / r.width - .5; const y = (e.clientY - r.top) / r.height - .5; b.style.setProperty('--tx', `${x * 14}px`); b.style.setProperty('--ty', `${y * 10}px`); b.style.setProperty('--tr', `${x * 10}deg`); });
      t.addEventListener('pointerleave', () => { b.style.removeProperty('--tx'); b.style.removeProperty('--ty'); b.style.removeProperty('--tr'); });
    });
  });

  /* ---------- counters: the ladder percentages count up when they appear ---------- */
  $$('.ladder b, [data-count-up]').forEach((el) => {
    const txt = el.textContent.trim(); const m = txt.match(/^(\d+)(.*)$/); if (!m) return;
    const o = { v: 0 }; const to = Number(m[1]); const suffix = m[2];
    gsap.to(o, { v: to, duration: 1.4, ease: 'power3.out', onUpdate: () => { el.textContent = Math.round(o.v) + suffix; }, scrollTrigger: { trigger: el, start: 'top 90%', once: true } });
  });

  /* ---------- parallax: anything marked data-parallax="0.2" drifts at that fraction of the scroll ---------- */
  $$('[data-parallax]').forEach((el) => {
    const k = Number(el.dataset.parallax || .15);
    gsap.fromTo(el, { yPercent: k * 40 }, { yPercent: -k * 40, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: .6 } });
  });

  /* ---------- coming soon: veiled bottles drift apart on scroll ---------- */
  $$('.soon__vis').forEach((v) => {
    gsap.fromTo($$('.btl--veiled', v), { y: 40, opacity: 0 }, { y: 0, opacity: .85, stagger: .1, duration: 1.2, ease: 'expo.out', scrollTrigger: { trigger: v, start: 'top 80%' } });
  });

  /* ---------- product page: bottle settles on load, turns to three-quarter as you read, ghost name drifts ---------- */
  $$('[data-pdp-stage]').forEach((st) => {
    const wrap = $('[data-hero-btl]:not(.pdp__btl--kit)', st); const ghost = $('.pdp__ghost span', st);
    const f = wrap && ($('img.btl:not(.btl--q)', wrap) || $('.btl', wrap)); const q = wrap && $('.btl--q', wrap);
    if (wrap) gsap.from(wrap, { yPercent: 14, rotate: 6 * dir, scale: .92, opacity: 0, duration: 1.4, ease: 'expo.out', delay: .1 });
    if (ghost) gsap.from(ghost, { xPercent: 12 * dir, opacity: 0, duration: 1.6, ease: 'expo.out' });
    if (q) gsap.set(q, { opacity: 0 });
    const mq = gsap.matchMedia();
    mq.add('(min-width: 990px)', () => {
      const tl = gsap.timeline({ scrollTrigger: { trigger: '.pdp__info', start: 'top top', end: 'bottom bottom', scrub: .8 } });
      if (wrap) tl.to(wrap, { rotate: -5 * dir, yPercent: -6, ease: 'none', duration: 1 }, 0);
      if (q && f) tl.to(f, { opacity: 0, ease: 'none', duration: .45 }, .15).to(q, { opacity: 1, ease: 'none', duration: .45 }, .15);
      if (ghost) tl.to(ghost, { xPercent: -18 * dir, ease: 'none', duration: 1 }, 0);
    });
    mq.add('(max-width: 989px)', () => {
      if (wrap) gsap.to(wrap, { yPercent: 18, scale: .9, ease: 'none', scrollTrigger: { trigger: st, start: 'top top', end: 'bottom top', scrub: .5 } });
    });
    if (fine && wrap) {
      st.addEventListener('pointermove', (e) => { const r = st.getBoundingClientRect(); const x = (e.clientX - r.left) / r.width - .5; const y = (e.clientY - r.top) / r.height - .5; wrap.style.setProperty('--tilt', `perspective(1200px) rotateY(${x * 12}deg) rotateX(${-y * 7}deg)`); });
      st.addEventListener('pointerleave', () => wrap.style.removeProperty('--tilt'));
    }
  });
  document.addEventListener('hc:look', () => {
    const b = $('[data-hero-btl]'); if (b) gsap.fromTo(b, { rotate: -4 * dir, scale: .97 }, { rotate: 0, scale: 1, duration: 1, ease: 'elastic.out(1, .6)' });
  });

  addEventListener('load', () => ScrollTrigger.refresh());
})();
